<template>
    <div ref="privacyPolicyLinkRef">
        <PrivacyPolicyPopup
          ref="privacyPolicyPopupRef"
          :privacyPolicyVisible="false"
        >
        </PrivacyPolicyPopup>

        <div class='center-text privacy-policy-link'>
            <DxButton
            ref="btnPrivacyPolicyRef"
            text="Privacy Policy"
            styling-mode="text"
            @click="btnPrivacyPolicyClick($event)"
            :element-attr="{
                    id: 'btnPrivacyPolicy',
                    class: 'btn-terms-and-conditions',  //I set a class here so I can style the button like a hyperlink
                }"
            />
        </div>
    </div>
</template>

<script>
    import {DxButton} from 'devextreme-vue';
    import PrivacyPolicyPopup from '../components/privacy-policy';

    export default {
        components: {
            DxButton,
            PrivacyPolicyPopup,
        },
        props: {
            someProp: String,
        },
        data(){
            return{
                privacyPolicyVisible: false,
            }
        },
        methods:{
            /*
                
            */
            btnPrivacyPolicyClick(e){
                //Show the Privacy Policy
                this.$refs.privacyPolicyPopupRef.$data.privacyPolicyVisibleYN = true;
            },
        }
    }
</script>

<style scoped>
  @import '../themes/contact-tracing.css';
  
  .style-one{
    margin:auto;
  }

  .privacy-policy-link{
      padding-top:10px;
  }

</style>
